module.exports = __webpack_public_path__ + "img/land_ocean_ice_cloud_2048.b07dffb3.jpg";